function conditionMet(condition, allCriteria) {
  const target = allCriteria?.find(crit => crit?.criterion?.criteriaMark == condition.targetCriterionMark
    || crit?.criterion?.criterionCode == condition.criterionCode)
  if (!target || !target.value) {
    return false
  }
  const targetValue = target.criterion.criterionControlType == 'DICTIONARY'
    ? target.criterion.dictionaryValues?.find(val => val.id == target.value)?.title
    : target.value
  if (targetValue === null || targetValue === undefined) {
    return false
  }
  const conditionValues = String(condition.value).split(',').map(v => v.trim())
  switch (condition.comparingMode) {
  case 'CONTAINS':
    return conditionValues.includes(String(targetValue).trim())
  case 'NOT_CONTAINS':
    return !conditionValues.includes(String(targetValue).trim())
  case 'EQUAL':
    return String(targetValue).trim() == conditionValues[0]
  case 'NOT_EQUAL':
    return String(targetValue).trim() != conditionValues[0]
  case 'MORE_THAN':
    return parseFloat(targetValue) > parseFloat(condition.value)
  case 'LESS_THAN':
    return parseFloat(targetValue) < parseFloat(condition.value)
  case 'MORE_OR_EQUAL':
    return parseFloat(targetValue) >= parseFloat(condition.value)
  case 'LESS_OR_EQUAL':
    return parseFloat(targetValue) <= parseFloat(condition.value)
  default:
    return false
  }
}

export default function isCriterionDisplayed(criterion, allCriteria) {
  if (!criterion) {
    return false
  }
  if (criterion.isDisplayed != 'ON_CONDITION') {
    return criterion.isDisplayed == 'ALWAYS'
  }
  const dynamic = criterion.dynamicCriterions
  return !!dynamic?.length && dynamic.every(condition => conditionMet(condition, allCriteria))
}
